export const trackGaEvent = (category, action, label) => {
  if (window['tagManager']) {
    window.tagManager.trackGenericEvent(category, action, label);
  }
  console.log('GA: event tracked', { category, action, label });
};

export const trackGaPageview = (path, title) => {
  if (window['tagManager']) {
    window.tagManager.trackGenericPageView(path, title);
  }
  console.log('GA: pageview tracked', { path, title });
};

export const trackGaRegistration = () => {
  if (window['tagManager']) {
    window.tagManager.trackRegistrationLandingpageCompleted();
  }
  console.log('GA: registration tracked');
};

export const trackGaAccountActivation = () => {
  if (window['tagManager']) {
    window.tagManager.trackAccountActivated();
  }
  console.log('GA: account activation tracked');
};

export const trackGaSmartApplyEvent = (label) => {
  trackGaEvent('Smart-Apply', 'Click', label);
};
